import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import { RecoilRoot } from "recoil";
import { PostHogProvider } from "posthog-js/react";
import config from "./config.js";
import "./index.css";
import "./globals.css";
import "../build.css";
import { SocketProvider } from "./socketprovider.jsx";
import { RouterProvider } from "react-router-dom";
import GlobalSocketHandler from "./globalsocket.jsx";
import router from "./router.jsx";
// import * as Sentry from "@sentry/react";
// import { initializeTracing } from './lib/otel.js';

// import { getSessionId } from "./lib/helper.js";
// let phoneNumber = null; // Will be set when available
// let sessionId = getSessionId()
// Initialize tracingconst sessionId = getSessionId();
// initializeTracing(sessionId);
// startOtelInstrumentation();

// if (import.meta.env.DEV) {
//   const whyDidYouRender = require('@welldone-software/why-did-you-render');
//   whyDidYouRender(React, {
//     trackAllPureComponents: true,
//   });
// }
function FallbackComponent({ error, componentStack, resetError }) {
  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 w-[329px] h-[114.79px] px-4 py-3 bg-neutral-800 rounded-[14px] flex flex-col justify-center items-center gap-1 shadow-lg z-50">
      <div className="self-stretch h-[34px] flex flex-col justify-start items-start">
        <div className="self-stretch">
          <span className="text-[#8c8c8c] text-sm font-normal font-['Montserrat']">
            Oops, something went wrong!
          </span>
        </div>
      </div>
      <div className="self-stretch h-[52.79px] flex justify-end items-center gap-[2.92px]">
        <button
          onClick={resetError}
          className="px-3 py-1.5 rounded-[52.46px] border border-[#b6b6b6] bg-transparent text-[#b6b6b6] text-xs font-medium font-['Poppins'] tracking-tight transition hover:bg-neutral-700"
        >
          Try Again!
        </button>
      </div>
    </div>
  );
}


  
  // <Sentry.ErrorBoundary fallback={<FallbackComponent />}>
 ReactDOM.createRoot(document.getElementById("root")).render(
  <React.Suspense fallback={<div>Loading...</div>}>
    <RecoilRoot>
      <SocketProvider>
        <App />
      </SocketProvider>
    </RecoilRoot>
  </React.Suspense>

  // </Sentry.ErrorBoundary>
);
